import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../services/modal.service';

import { CampaignYearPipe } from '../../../pipes/campaignYear.pipe';
import { ZSNCampaign, ZSNCampaignConfiguration } from '../../../models/zsn.model';
import { ZSNService } from '../../../services/zsn.service';
import { correctDate, showErrorMessage } from '../../../utils/utils';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  standalone: true,
  selector: 'zsn-campaign-config-edit',
  templateUrl: 'campaign-config-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, CampaignYearPipe, TranslatePipe, FormsModule, BsDatepickerModule],
  providers: [ZSNService],
})
export class ZSNCampaignConfigurationEditComponent implements OnInit, OnDestroy {
  @Input() config: ZSNCampaignConfiguration;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;

  edited = false;

  configId: number;
  isStartingOnCollapsed: boolean = false;
  isEndingOnCollapsed: boolean = false;
  campaign: ZSNCampaign;

  constructor(
    private zsnService: ZSNService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  goBack(savedConfig: ZSNCampaignConfiguration = null) {
    this.close.emit(savedConfig);
    this.router.navigate(['/orders', 'zsn', 'admin']);
    return false;
  }

  save() {
    if (this.config.startingOn) {
      this.config.startingOn = correctDate(<Date>this.config.startingOn);
    }

    if (this.config.endingOn) {
      this.config.endingOn = correctDate(<Date>this.config.endingOn);
    }

    this.zsnService.saveCampaignConfiguration(this.config).subscribe(
      (config) => {
        this.config = config;
        this.goBack(config);
      },
      (error) => this.handleSaveError(error),
    );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[3].path === 'new') {
        this.edited = false;
        this.config = new ZSNCampaignConfiguration();
        this.config.campaign = new ZSNCampaign();
        if (params['campaignId']) {
          this.config.campaign.id = +params['campaignId'];
          this.getCampaign(this.config.campaign.id);
        } else {
          showErrorMessage(this.modal, 'Pas de campagne spécifiée').then((r) => {
            this.router.navigate(['/orders', 'zsn', 'admin']);
          });
        }
        this.isStartingOnCollapsed = true;
        this.isEndingOnCollapsed = true;
      } else if (this.route.snapshot.url[3].path === 'edit') {
        this.configId = +params['configId'];
        this.edited = true;
        // FIXME traiter les erreurs ; afficher un message
        this.zsnService.getCampaignConfiguration(this.configId).subscribe(
          (config) => {
            this.config = config;
            this.campaign = config.campaign;
          },
          (e) => this.handleGetError(e),
        );
      }
    });
  }

  getCampaign(campaignId: number) {
    this.zsnService.getCampaign(campaignId).subscribe(
      (campaign) => {
        this.campaign = campaign;
      },
      (error) => this.handleGetError(error),
    );
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à consulter cette configuration").then((r) => {
        this.router.navigate(['/orders', 'zsn']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/orders', 'zsn', 'admin']);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
